import { BatchStats, JobStatus } from "../../../pages/playground/types";

/**
 * Derived statistics calculated from batch stats and sheet data
 */
export interface DerivedStats {
  totalLoadedJobs: number;
  jobsInNotReadyStatus: number;
  jobsThatCanBeWorked: number;
  missingGarmentTypes: number;
  missingImagesInGDrive: number;
  aiProcessingJobs: number;
  atLeastOneJobMissingImages: boolean;
  atLeastOneJobAiProcessing: boolean;
  realMissingGarmentTypes: number;
  atLeastOneRealMissingGarmentType: boolean;
  areAllJobsWithoutImages: boolean;
}

/**
 * Calculate derived statistics from batch stats
 *
 * @param stats - Batch statistics from the API
 * @returns Derived statistics object
 */
export function calculateDerivedStats(stats: BatchStats | null): DerivedStats {
  const totalLoadedJobs = stats?.total_jobs || 0;
  const jobsInNotReadyStatus =
    stats?.jobs_by_status?.[JobStatus.NOT_READY] || 0;
  const jobsThatCanBeWorked = totalLoadedJobs - jobsInNotReadyStatus;

  const missingGarmentTypes = stats?.garment_types_count?.["missing"] || 0;
  const missingImagesInGDrive = stats?.jobs_with_missing_images_in_gdrive || 0;
  const aiProcessingJobs = stats?.jobs_with_ai_processing || 0;

  const atLeastOneJobMissingImages = missingImagesInGDrive > 0;
  const atLeastOneJobAiProcessing = aiProcessingJobs > 0;

  const realMissingGarmentTypes = missingGarmentTypes - missingImagesInGDrive;
  const atLeastOneRealMissingGarmentType = realMissingGarmentTypes > 0;

  const areAllJobsWithoutImages =
    (stats?.jobs_without_images || 0) >= totalLoadedJobs;

  return {
    totalLoadedJobs,
    jobsInNotReadyStatus,
    jobsThatCanBeWorked,
    missingGarmentTypes,
    missingImagesInGDrive,
    aiProcessingJobs,
    atLeastOneJobMissingImages,
    atLeastOneJobAiProcessing,
    realMissingGarmentTypes,
    atLeastOneRealMissingGarmentType,
    areAllJobsWithoutImages,
  };
}
